import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { listTemplateCategories, addCategory, updateCategory, deleteCategory } from "../../actions/inventory.action";
import CustomTable from "../../components/table/table";
import CustomInput from "../../components/inputs/new-input";
import { Modal } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import DialogActions from "@mui/material/DialogActions";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ValidateField, ValidatorTypes } from "../../util/validators";
import SelectInput from "../../components/inputs/select"; // Add this import

export default function TemplateCategory({ open, dialogClose, fetchItemTemplates, resetSelectedCategories, type = "", defaultCategoryName = "" }) {
  const dispatch = useDispatch();
  const categoryList = useSelector((state) => state.category.categories) || [];

  const [fields, setFields] = useState({
    selectedCategoryId: {
      label: 'Category',
      type: 'text',
      touched: false,
      error: false,
      valid: true,
      value: '',
      validation: [ValidatorTypes.REQUIRED],
    },
    name: {
      name: 'name',
      type: 'text',
      label: 'Category Name',
      value: defaultCategoryName,
      touched: false,
      error: false,
      valid: true,
      validation: [ValidatorTypes.REQUIRED],
    },
  });

  const [categoryId, setCategoryId] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [showList, setShowList] = useState(type === "subtask" ? false : true);

  useEffect(() => {
    if (categoryList.length === 0) dispatch(listTemplateCategories()).catch(e => console.log(e))
  }, []);
  useEffect(() => {
    setFields((prev) => {
      const newFields = {
        ...prev,
        name: {
          ...prev.name,
          value: defaultCategoryName,
        },
      };
      if (open) {
        newFields.selectedCategoryId = {
        ...prev.selectedCategoryId,
        value: '',
        };
      }
      return newFields;
    });
  }, [open, defaultCategoryName]);

  const swapCategoryChangeHandler = (event) => {
    const updatedFields = { ...fields };
    updatedFields.selectedCategoryId.value = event.target.value;
    updatedFields.selectedCategoryId.touched = true;
    setFields(updatedFields);
  };

  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    const { error, valid } = ValidateField({ value, validation: fields[name].validation });
    setFields((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value,
        touched: true,
        error,
        valid,
      },
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const updatedFields = { ...fields };
    const keysToValidate = ["name"];
    keysToValidate.forEach((key) => {
      const field = updatedFields[key];
      const { error, valid } = ValidateField({ value: field.value, validation: field.validation });
      updatedFields[key] = { ...field, touched: true, error, valid };
      isValid = isValid && valid;
    });
    setFields((prev) => ({
      ...prev,
      name: updatedFields.name,
    }));
    return isValid;
  };

  const resetForm = () => {
    setFields((prev) => ({ ...prev, name: { ...prev.name, value: "" } }));
    setCategoryId("");
    setShowList(type !== "subtask");
    dispatch(listTemplateCategories()).catch(e => console.log(e));
    dialogClose();
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const categoryData = { name: fields.name.value, type: "2" };
      const onSuccess = (savedCategory) => {
        if (type === "subtask") {
          dialogClose(savedCategory);
        }
        if (savedCategory.id) {
            resetForm();
        }
      };
      if (categoryId) {
        dispatch(updateCategory(categoryData, categoryId)).then((res) => { onSuccess(res); }).catch((err) => console.error(err));
      } else {
        dispatch(addCategory(categoryData)).then((res) => { onSuccess(res); }).catch((err) => console.error(err));
      }
    }
  };
  const handleEdit = (category) => {
    setShowList(false);
    setFields((prev) => ({
      ...prev,
      name: {
        ...prev.name,
        value: category.name || "",
        touched: false,
        error: false,
        valid: true,
      },
    }));
    setCategoryId(category.value || "");
  };

  const handleDelete = (id, replacementId) => {
    dispatch(deleteCategory({ itemId: id, categoryId: replacementId }))
      .then(() => {
        setOpenDeleteDialog(false);
        resetForm();
        fetchItemTemplates();
        resetSelectedCategories();
      })
      .catch((err) => console.error(err));
  };

  const deleteDescription = () => {
    const category = categoryList.find((cat) => cat.value === deleteId);
    return category ? category.name : "";
  };

  const columns = [
    { title: "Category Name", field: "templateNameWithCount", class: "text-start" },
    {
      title: "Action",
      field: "action",
      class: "text-end",
      render: (rowData) => (
        <div className="d-flex gap-2 justify-content-end">
          <div className="action-edit">
            <EditIcon onClick={() => handleEdit(rowData)} />
          </div>
          <div className="action-edit">
            <DeleteIcon className="deleteicon" onClick={() => { setOpenDeleteDialog(true); setDeleteId(rowData.value); }} />
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        show={open}
        onHide={dialogClose}
        centered
        backdrop="static"
        dialogClassName="create-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div class="modal-title h4" id="example-custom-modal-styling-title">{showList ? "Category List" : categoryId ? "Update Category" : "Add Category"}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-4">
          {showList ? (
            <CustomTable columns={columns} addButton={true} data={categoryList} isAdd={true} limit={10} addHandler={() => handleEdit({})} />
          ) : (
            <div>
              <CustomInput {...fields.name} onChange={inputChangeHandler} />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {showList ? null : (
            <DialogActions>
              <Button onClick={handleSubmit} className="ms-auto me-3 secondarybtn">Save</Button>
              <Button onClick={resetForm} className="secondarybtn cancelbtn me-auto">Cancel</Button>
            </DialogActions>
          )}
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        show={openDeleteDialog}
        onHide={() => setOpenDeleteDialog(false)}
        centered
        backdrop="static"
        dialogClassName="create-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Item Template Category</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-4">
          <p>Are you sure you want to delete this Item Template Category - {deleteDescription()}?</p>
          <p>To do so please select the category you would like to move item templates within this category to. Then select Save. Otherwise select Cancel to exit.</p>
          <div className="col-12 mt-3 mb-4">
            <SelectInput
              {...fields.selectedCategoryId}
              onChange={swapCategoryChangeHandler}
              items={categoryList
                .filter((category) => category.value !== deleteId)
                .map((category) => ({
                  key: category.name,
                  value: category.value,
                }))
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <DialogActions>
            <Button onClick={() => handleDelete(deleteId, fields.selectedCategoryId.value)} className="ms-auto me-3 secondarybtn">Delete</Button>
            <Button onClick={() => setOpenDeleteDialog(false)} className="secondarybtn cancelbtn me-auto">Cancel</Button>
          </DialogActions>
        </Modal.Footer>
      </Modal>
    </>
  );
}
